import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiTerminal } from 'react-icons/fi';
import Footer from '../../components/Footer';

const RAINBOW = [
  '#ff0040','#ff4000','#ff8000','#ffc000',
  '#ffff00','#80ff00','#00ff80','#00ffff',
  '#0080ff','#4000ff','#8000ff','#ff00ff',
];

function rainbowText(text) {
  const chars = text.split('');
  const vis = chars.filter(c => c !== ' ').length;
  let ci = 0;
  return chars.map((ch, i) => {
    if (ch === ' ') return <span key={i}>&nbsp;</span>;
    const color = RAINBOW[Math.floor((ci / vis) * RAINBOW.length) % RAINBOW.length];
    ci++;
    return <span key={i} style={{ color }}>{ch}</span>;
  });
}

/* Typewriter for terminal line */
function TerminalTyper({ text, delay = 1200 }) {
  const [shown, setShown] = useState(0);
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t0 = setTimeout(() => {
      const iv = setInterval(() => {
        setShown(s => {
          if (s >= text.length) { clearInterval(iv); setDone(true); return s; }
          return s + 1;
        });
      }, 38);
      return () => clearInterval(iv);
    }, delay);
    return () => clearTimeout(t0);
  }, [text, delay]);
  return (
    <span>
      {text.slice(0, shown)}
      <span className={`ph-cursor ${done ? 'blink' : ''}`}>_</span>
    </span>
  );
}

const products = [
  {
    name: 'Wallet King',
    tagline: 'Budget Tracker',
    desc: 'The personal budget tracker that reads your statements. Upload a PDF, CSV, or OFX, or link a bank, and keep one ledger for income, expenses, merchants, and savings.',
    mark: '/wallet-king-icon.svg',
    color: '#00ff80',
    glow: 'rgba(0,255,128,0.25)',
    link: '/products/wallet-king',
    status: 'live',
    cta: 'Open app',
    highlights: ['Statement OCR', 'One ledger', 'Bank linking'],
    cmd: 'wallet-king --import statement.pdf',
  },
];

export default function ProductsHub() {
  return (
    <div className="products-page ph-v2">
      {/* Hero */}
      <section className="ph-hero">
        <div className="ph-hero-inner">
          <div className="ph-terminal-badge">
            <FiTerminal /> <span>product_studio</span>
          </div>
          <h1 className="ph-title">
            {rainbowText('PRODUCTS')}
          </h1>
          <p className="ph-subtitle">
            Fullstack applications in production.
          </p>
          <div className="ph-cli">
            <div className="ph-cli-header">
              <span className="ph-dot" style={{background:'#ff5f57'}}></span>
              <span className="ph-dot" style={{background:'#febc2e'}}></span>
              <span className="ph-dot" style={{background:'#28c840'}}></span>
              <span className="ph-cli-title">vector-labs ~ products</span>
            </div>
            <div className="ph-cli-body">
              <div className="ph-cli-line">
                <span className="ph-prompt">$</span>
                <TerminalTyper text="vector-labs --list-products" delay={800} />
              </div>
              <div className="ph-cli-output">
                <br/>
                <span style={{color:'rgba(255,255,255,0.35)'}}>  NAME        TYPE                  STATUS</span><br/>
                <span style={{color:'#00ff80'}}>  eligibl.org</span><br/>
                <span style={{color:'#00ff80'}}>  wallet-king.app</span><br/>
                <span style={{color:'#00ff80'}}>  calderacompliance.com</span><br/>
                <br/>
                <span style={{color:'rgba(255,255,255,0.3)'}}>  3 applications in production.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ul className="production-apps">
        <li><a href="https://eligibl.org">eligibl.org</a><span>Aid eligibility</span></li>
        <li><a href="https://wallet-king.app">wallet-king.app</a><span>Budget tracker</span></li>
        <li><a href="https://calderacompliance.com">calderacompliance.com</a><span>Compliance</span></li>
      </ul>

      <section className="ph-grid">
        {products.map((p, i) => (
          <Link
            to={p.link}
            key={p.name}
            className="ph-card"
            style={{ '--card-color': p.color, '--card-glow': p.glow }}
          >
            <div className="ph-card-top">
              <div className="ph-card-icon">{p.mark ? <img src={p.mark} alt="" width="28" height="28" /> : p.icon}</div>
              <span className="ph-card-status" style={{color: p.status === 'live' ? '#00ff80' : '#ffc000'}}>
                {p.status === 'live' ? '● live' : '◌ beta'}
              </span>
            </div>
            <h2 className="ph-card-name">{p.name}</h2>
            <span className="ph-card-tagline">{p.tagline}</span>
            <p className="ph-card-desc">{p.desc}</p>
            <div className="ph-card-cli">
              <span className="ph-prompt-mini">$</span> {p.cmd}
            </div>
            <div className="ph-card-stats">
              {p.highlights.map(s => <span key={s} className="ph-chip">{s}</span>)}
            </div>
            <span className="ph-card-link">
              {p.cta || 'Join Beta'} <FiArrowRight />
            </span>
          </Link>
        ))}
      </section>

      {/* CTA */}
      <section className="ph-cta">
        <h2>Open Wallet King</h2>
        <p>The budget tracker is live. Upload a statement or link a bank.</p>
        <a href="https://wallet-king.app" className="ph-cta-btn">
          <span>{rainbowText('wallet-king.app')}</span> <FiArrowRight />
        </a>
      </section>

      <Footer />
    </div>
  );
}
